import React from 'react';
import { Header } from '../Header';
import { Footer } from '../Footer';
export function TermsAndConditions() {
  return <div className="w-full bg-white" data-id="element-378">
      <Header data-id="element-379" />
      <main className="pt-28 pb-16 bg-white" data-id="element-380">
        <div className="container mx-auto px-4" data-id="element-381">
          <div className="max-w-3xl mx-auto" data-id="element-382">
            <h1 className="text-3xl font-bold text-amber-800 mb-8" data-id="element-383">
              Términos y Condiciones
            </h1>
            <div className="prose prose-amber" data-id="element-384">
              <p data-id="element-385">Última actualización: {new Date().toLocaleDateString()}</p>
              <h2 data-id="element-386">1. Aceptación de los Términos</h2>
              <p data-id="element-387">
                Al acceder y utilizar el sitio web de Picadas Fáciles, usted
                acepta cumplir con estos términos y condiciones de uso. Si no
                está de acuerdo con alguna parte de estos términos, no podrá
                acceder al sitio web ni utilizar nuestros servicios.
              </p>
              <h2 data-id="element-388">2. Descripción del Servicio</h2>
              <p data-id="element-389">
                Picadas Fáciles ofrece contenido digital educativo relacionado
                con la preparación de picadas, que incluye pero no se limita a
                guías, recetas, planificadores y recursos visuales.
              </p>
              <h2 data-id="element-390">3. Propiedad Intelectual</h2>
              <p data-id="element-391">
                Todo el contenido presente en este sitio web, incluyendo textos,
                gráficos, logos, imágenes y software, está protegido por
                derechos de autor y otras leyes de propiedad intelectual. Este
                contenido es propiedad exclusiva de Picadas Fáciles. Está
                prohibida la reproducción, distribución o comercialización no
                autorizada de nuestros materiales.
              </p>
              <h2 data-id="element-392">4. Uso del Contenido Digital</h2>
              <p data-id="element-393">
                Al adquirir nuestros productos digitales, se le otorga una
                licencia personal, no exclusiva y no transferible para acceder y
                utilizar el contenido para uso personal. No está permitido
                compartir, revender o distribuir el contenido a terceros.
              </p>
              <h2 data-id="element-394">5. Política de Reembolsos</h2>
              <p data-id="element-395">
                Debido a la naturaleza digital de nuestros productos, no
                ofrecemos reembolsos una vez que el contenido ha sido descargado
                o accedido. Sin embargo, evaluaremos cada caso particular si
                existe algún problema técnico con la descarga.
              </p>
              <h2 data-id="element-396">6. Limitación de Responsabilidad</h2>
              <p data-id="element-397">
                Picadas Fáciles no será responsable por daños directos,
                indirectos, incidentales o consecuentes que puedan surgir del
                uso o la imposibilidad de usar nuestros servicios o contenidos.
              </p>
              <h2 data-id="element-398">7. Modificaciones de los Términos</h2>
              <p data-id="element-399">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. Las modificaciones entrarán en vigor
                inmediatamente después de su publicación en el sitio web. Es su
                responsabilidad revisar periódicamente estos términos.
              </p>
              <h2 data-id="element-400">8. Legislación Aplicable</h2>
              <p data-id="element-401">
                Estos términos se regirán e interpretarán de acuerdo con las
                leyes de la República Argentina, sin consideración a sus
                disposiciones sobre conflicto de leyes.
              </p>
              <h2 data-id="element-402">9. Contacto</h2>
              <p data-id="element-403">
                Si tiene alguna pregunta sobre estos Términos y Condiciones,
                puede contactarnos a través de nuestro formulario de contacto o
                por correo electrónico.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-404" />
    </div>;
}